// Module
var code = "<h2 id=\"loans-in-default\">Loans in Default?</h2> <p>If your loans are currently in default and you&#39;d like to sign up for Direct Debit, please complete, sign, and submit the Direct Debit Default Collections Agreement and retain a completed copy for your records.</p> ";
// Exports
export default code;